import PropTypes from 'prop-types';
import {Table, Button} from 'antd';
import {EyeOutlined} from '@ant-design/icons';
import {useState} from 'react';
import styles from './financial.module.scss';
import DBModal from 'components/modal/modal';

export const OrderMetricsCard = ({title, items, loading}) => {
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedList, setSelectedList] = useState(null);
  const [selectedTitle, setSelectedTitle] = useState('');

  const handleViewList = (list, title) => {
    setSelectedList(list);
    setSelectedTitle(title);
    setModalVisible(true);
  };

  const getTableColumns = list => {
    if (!list || list.length === 0) return [];

    const sampleItem = list[0];
    return Object.keys(sampleItem).map(key => ({
      title: key
        .replace(/([A-Z])/g, ' $1')
        .replace(/^./, str => str.toUpperCase()),
      dataIndex: key,
      key: key,
      render: value =>
        typeof value === 'number' ? value.toLocaleString() : value,
    }));
  };

  if (loading) {
    return (
      <div className={styles.metricCardBox}>
        <h2 className={styles.sectionTitle}>{title}</h2>
        <div className={styles.metricCardList}>
          {Array(3)
            .fill('')
            .map((_, key) => (
              <div key={key} className={styles.loadingSkeleton}>
                {_}
              </div>
            ))}
        </div>
      </div>
    );
  }

  return (
    <>
      <div className={styles.metricCardBox}>
        <h2 className={styles.sectionTitle}>{title}</h2>
        <div className={styles.metricCardList}>
          {items &&
            Array.isArray(items) &&
            items.map((item, index) => (
              <div key={index} className={styles.simpleMetricCard}>
                <div className={styles.cardHeader}>
                  <p className={styles.cardLabel}>{item.type}</p>
                  {item.list &&
                    Array.isArray(item.list) &&
                    item.list.length > 0 && (
                      <Button
                        type="text"
                        size="small"
                        icon={<EyeOutlined />}
                        onClick={() => handleViewList(item.list, item.type)}
                        className={styles.viewButton}
                      />
                    )}
                </div>
                <h1 className={styles.cardAmount}>
                  {item.total?.toLocaleString()}
                </h1>

                {/* Show data breakdown if present */}
                {item.data && typeof item.data === 'object' && (
                  <div className={styles.dataBreakdown}>
                    {Object.entries(item.data).map(([key, value]) => (
                      <div key={key} className={styles.breakdownItem}>
                        <span className={styles.breakdownLabel}>
                          {key
                            .replace(/([A-Z])/g, ' $1')
                            .replace(/^./, str => str.toUpperCase())}
                        </span>
                        <span className={styles.breakdownValue}>
                          {typeof value === 'number'
                            ? value.toLocaleString()
                            : value}
                        </span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}
        </div>
      </div>

      <DBModal
        isOpen={modalVisible}
        handleClose={() => setModalVisible(false)}
        width={800}
        content={
          <div className={styles.listModal}>
            <h1>{selectedTitle}</h1>
            <Table
              className="antd-table"
              columns={getTableColumns(selectedList)}
              dataSource={selectedList}
              rowKey={(row, index) => row?.id || index}
              scroll={{y: 500}}
            />
          </div>
        }
      />
    </>
  );
};

OrderMetricsCard.propTypes = {
  title: PropTypes.string.isRequired,
  items: PropTypes.array,
  loading: PropTypes.bool,
};

OrderMetricsCard.defaultProps = {
  items: [],
  loading: false,
};
